// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8792) return "main.365cb82a.css";
	// return url for filenames based on template
	return "" + chunkId + "." + {"2805":"32c410ba","5971":"6df9578f","6851":"4152b795","8577":"46657d27","8703":"b0c8a2ae"}[chunkId] + ".chunk.css";
};